module.exports = __webpack_public_path__ + "img/Picture7.d3b9335c.jpg";